<template>
    <fwb-navbar>
        <template #logo>
            <Link href="/dashboard">
                <p class="text-xl font-bold">{{ appName }}</p>
            </Link>
        </template>
        <template #default="{ isShowMenu }">
            <fwb-navbar-collapse
                class="flex w-full"
                :is-show-menu="isShowMenu"
                id="navbar"
            >
                <Link
                    v-for="item in navbarItems"
                    :key="item.name"
                    :href="item.href"
                    class="text-xs"
                >
                    <fwb-navbar-link>
                        <span :class="{ 'text-red-400 hover:text-red-600': item.isAdmin }">{{ item.name }}</span>
                    </fwb-navbar-link>
                </Link>
            </fwb-navbar-collapse>
        </template>
    </fwb-navbar>
</template>
<style>
#navbar ul {
    width: 100%;
}
</style>

<script setup>
import { FwbNavbar, FwbNavbarCollapse, FwbNavbarLink } from "flowbite-vue";
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import { Link } from "@inertiajs/vue3";

const navbarItems = computed(() => {
    const items = [{ name: `Home`, href: "/dashboard" }];
    if (user.value && user.value.is_admin) {
        items.push({ name: "Manage Users", href: "/admin/users", isAdmin: true });
        items.push({ name: "Edit Form", href: `/affiliates/${authUserAffiliate.value.short_uuid}/edit`, isAdmin: true });
    }
    if (!user.value) {
        items.push({ name: "Login", href: "/login", isAdmin: false });
    } else {
        items.push({
            name: 'Reports',
            href: `/affiliates/${authUserAffiliate.value.short_uuid}/reports`,
            isAdmin: false
        })
        items.push({
            name: 'Submissions',
            href: `/affiliates/${authUserAffiliate.value.short_uuid}/submissions`,
            isAdmin: false
        })
        items.push({
            name: 'Links',
            href: `/affiliates/${authUserAffiliate.value.short_uuid}/links`,
            isAdmin: false
        })
        items.push({
            name: `Logout (${user.value.username})`,
            href: "/logout",
            isAdmin: false
        });
    }

    return items;
});
const page = usePage();
const user = computed(() => page?.props?.authUser);
const authUserAffiliate = computed(() => page?.props?.authUserAffiliate);
const appName = computed(() => page?.props?.appName);
</script>
